import app from 'flarum/forum/app';

// Same cfId vocabulary as champis-species (SpeciesAssignModal.js's own
// confidenceOptions()) and the old reference exhibitions tool - but flat,
// not rank-aware: logging a finding at a fair doesn't need the
// family/order-specific label wording SpeciesAssignModal uses for formal
// site-wide taxonomic assignment.
export default function confidenceOptions() {
  const t = key => app.translator.trans(`champis-exhibitions.forum.confidence.${key}`);
  return [{
    cfId: 0,
    label: t('certain')
  }, {
    cfId: 1,
    label: t('uncertain_species')
  }, {
    cfId: 2,
    label: t('uncertain_genus')
  }, {
    cfId: 3,
    label: t('broad')
  }];
}
flarum.reg.add('champis-exhibitions', 'forum/utils/confidenceOptions', confidenceOptions);